import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';

import Container from 'components/Container';
import { Button } from '@mui/material';

const Y2026 = () => {

  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

//   const pdf1 = `${config.base_image_url_2025}/home/achievements2026/class10-results-2026/1.webp`;
//   const pdf2 = `${config.base_image_url_2025}/home/achievements2026/class10-results-2026/2.webp`;

  const theme = useTheme();

  const mock = [
    {
      name: 'Results Class 10',
      title: 'Click here',
      href:'/class10-results-2026',
    },
    {
      name: 'Results Class 12',
      title: 'Click here',
      href:'/class12-results-2026',
    },
    {
      name: 'JEE MAIN TOPPERS 2025-26',
      title: 'Click here',
      href:'/jee-results-2026',
    },
    {
      name: 'JEE ADVANCED ACHIEVERS 2025-26',
      title: 'Click here',
      href:'/jee-advanced-results-2026',
    },
     {
      name: 'Class 10 Centum Winners',
      title: 'Click here',
      
      href: '/class10-centum-winners-2026'
    },
    {
      name: 'Class 12 Centum Winners',
      title: 'Click here',
     
      href: '/class12-centum-winners-2026'
    },
    // {
    //   name: 'Class 12 Centum Winners',
    //   title: 'Click here',
     
    //   href: '/class12-centum-winners-2025'
    // },
    {
      name: 'Merit Scholarship  2026-27',
      title: 'Click here',
     
      href: '/merit-scholarship-2026'
    },
  
  ];

  return (
    <Container>
      <Box>
        <Box marginBottom={4}>
          <Typography
            sx={{
              textTransform: 'uppercase',
            }}
            gutterBottom
            color={'text.secondary'}
            align={'center'}
            fontWeight={700}
          >
            ACHIEVEMENTS 2026
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {mock.map((item, i) => (
            <Grid item xs={12} md={4} key={i}>
              <Box
                width={1}
                height={1}
                component={Card}
                boxShadow={0}
                variant={'outlined'}
                bgcolor={'alternate.main'}
              >
                <CardContent sx={{ padding: 3 }}>
                  <ListItem component="div" disableGutters sx={{ padding: 0 }}>
                  
                    <Button 
                    href={item.href } target="_blank">
                    <ListItemText
                      sx={{ margin: 0 }}
                      primary={item.name}
                      secondary={item.title}
                      primaryTypographyProps={{
                        variant: 'h6',
                        fontWeight: 700,
                      }}
                      secondaryTypographyProps={{ variant: 'subtitle1' }}
                    />
                    </Button>
                  </ListItem>
                </CardContent>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default Y2026;

